import {
  FETCH_WEATHER_PROVIDERS,
  FETCH_WEATHER_PROVIDERS_SUCCESS,
  FETCH_WEATHER_PROVIDERS_FAILURE
} from "../../store/constants/hwk";

const initialState = {
  data: [],
  isFetching: false,
  error: false,
  errorDescription: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    // FETCH
    case FETCH_WEATHER_PROVIDERS:
      return {
        ...state,
        isFetching: true
      };
    // SUCCESS
    case FETCH_WEATHER_PROVIDERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.data
      };
    // FAILURE
    case FETCH_WEATHER_PROVIDERS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true,
        errorDescription: action.error
      };
    default:
      return state;
  }
}
